@if (data) {
  <lg-link-menu class="link-list">
    @for (button of data["ctaButtons"]; let i = $index; track i) {
      <dotcom-frontend-link
        [adobeData]="{
          interactionContainer: data['interactionContainer'],
          interactionLink: button['href'],
          interactionName: button['text'],
          interactionPage: pageTitle,
          interactionRegion: '',
          interactionType: 'ButtonClick',
          interactionDetails: ''
        }"
        [extension]="button['extension']"
        [fileSize]="button['fileSize']"
        [target]="button['target']"
        [url]="button['href']"
      >
        <span>
          <lg-link-menu-item
            [ngClass]="button['extension'] ? 'media-button' : ''"
          >
            <lg-link-menu-item-text [isBold]="true">
              {{ button["text"] }}
              @if (button["extension"]) {
                <span>
                  {{ button["extension"] + " - " + button["fileSize"] }}
                </span>
              }
            </lg-link-menu-item-text>
          </lg-link-menu-item>
        </span>
      </dotcom-frontend-link>
    }
  </lg-link-menu>
}
